export const ADD_TO_CART = 'EDITOR/ADD_TO_CART';
export const ADD_TO_CART_SUCCESS = 'EDITOR/ADD_TO_CART_SUCCESS';
export const ADD_TO_CART_ERROR = 'EDITOR/ADD_TO_CART_ERROR';
export const ADD_FAVORITE = 'EDITOR/ADD_FAVORITE';
export const ADD_FAVORITE_SUCCESS = 'EDITOR/ADD_FAVORITE_SUCCESS';
export const ADD_FAVORITE_ERROR = 'EDITOR/ADD_FAVORITE_ERROR';
export const CHECK_FAVORITE = 'EDITOR/CHECK_FAVORITE';
export const CHECK_FAVORITE_SUCCESS = 'EDITOR/CHECK_FAVORITE_SUCCESS';
export const CHECK_FAVORITE_ERROR = 'EDITOR/CHECK_FAVORITE_ERROR';
export const FETCH_CHECK_CONTROL = 'EDITOR/FETCH_CHECK_CONTROL';
export const FETCH_CHECK_CONTROL_SUCCESS = 'EDITOR/FETCH_CHECK_CONTROL_SUCCESS';
export const FETCH_CHECK_CONTROL_ERROR = 'EDITOR/FETCH_CHECK_CONTROL_ERROR';
export const SET_TEMPLATE_CODE = 'EDITOR/SET_TEMPLATE_CODE';
export const SET_NAME = 'EDITOR/SET_NAME';
export const SET_CREDENTIALS = 'EDITOR/SET_CREDENTIALS';
export const SET_TITLE1 = 'EDITOR/SET_TITLE1';
export const SET_TITLE2 = 'EDITOR/SET_TITLE2';
export const SET_TITLE3 = 'EDITOR/SET_TITLE3';
export const SET_DEPARTMENT1 = 'EDITOR/SET_DEPARTMENT1';
export const SET_DEPARTMENT2 = 'EDITOR/SET_DEPARTMENT2';
export const SET_DEPARTMENT3 = 'EDITOR/SET_DEPARTMENT3';
export const SET_PHONE = 'EDITOR/SET_PHONE';
export const SET_CLINIC = 'EDITOR/SET_CLINIC';
export const SET_FAX = 'EDITOR/SET_FAX';
export const SET_PAGER = 'EDITOR/SET_PAGER';
export const SET_ADDRESS = 'EDITOR/SET_ADDRESS';
export const SET_ADDRESS2 = 'EDITOR/SET_ADDRESS2';
export const SET_ADDRESS3 = 'EDITOR/SET_ADDRESS3';
export const SET_CITY = 'EDITOR/SET_CITY';
export const SET_STATE = 'EDITOR/SET_STATE';
export const SET_ZIP = 'EDITOR/SET_ZIP';
export const SET_EMAIL = 'EDITOR/SET_EMAIL';
export const SET_SHOW_EMAIL = 'EDITOR/SET_SHOW_EMAIL';
export const SET_OPEN1 = 'EDITOR/SET_OPEN1';
export const SET_OPEN2 = 'EDITOR/SET_OPEN2';
export const SET_OPEN3 = 'EDITOR/SET_OPEN3';
export const SET_QUANTITY = 'EDITOR/SET_QUANTITY';
export const SET_FRONT_DATA_URL = 'EDITOR/SET_FRONT_DATA_URL';
export const SET_BACK_DATA_URL = 'EDITOR/SET_BACK_DATA_URL';
export const SET_CELL = 'EDITOR/SET_CELL';
export const SET_SHOW_CELL = 'EDITOR/SET_SHOW_CELL';
export const SET_LOCATION_NAMES = 'EDITOR/SET_LOCATION_NAMES';
export const SET_LOCATION_PHONES = 'EDITOR/SET_LOCATION_PHONES';
export const SET_LOCATION_FAXES = 'EDITOR/SET_LOCATION_FAXES';
export const SET_LOCATION_NURSE_PHONES = 'EDITOR/SET_LOCATION_NURSE_PHONES';
export const SET_LOCATION_ADDRESSES1 = 'EDITOR/SET_LOCATION_ADDRESSES1';
export const SET_LOCATION_ADDRESSES2 = 'EDITOR/SET_LOCATION_ADDRESSES2';
export const SET_LOCATION_ADDRESSES3 = 'EDITOR/SET_LOCATION_ADDRESSES3';
export const SET_LOCATION_SUITES = 'EDITOR/SET_LOCATION_SUITES';
export const SET_LOCATION_CITIES = 'EDITOR/SET_LOCATION_CITIES';
export const SET_LOCATION_STATES = 'EDITOR/SET_LOCATION_STATES';
export const SET_LOCATION_ZIPS = 'EDITOR/SET_LOCATION_ZIPS';
export const SET_COLOR = 'EDITOR/SET_COLOR';
export const SET_STOCK = 'EDITOR/SET_STOCK';
export const SET_TITLES = 'EDITOR/SET_TITLES';
export const SET_NOTES = 'EDITOR/SET_NOTES';
export const SET_CONTACT1_PHONE = 'EDITOR/SET_CONTACT1_PHONE';
export const SET_CONTACT1_TYPE = 'EDITOR/SET_CONTACT1_TYPE';
export const SET_CONTACT2_PHONE = 'EDITOR/SET_CONTACT2_PHONE';
export const SET_CONTACT2_TYPE = 'EDITOR/SET_CONTACT2_TYPE';
export const SET_QUANTITY1 = 'EDITOR/SET_QUANTITY1';
export const SET_QUANTITY2 = 'EDITOR/SET_QUANTITY2';
export const SET_QUANTITY3 = 'EDITOR/SET_QUANTITY3';
export const SET_LOCATIONS = 'EDITOR/SET_LOCATIONS';
export const SET_FRONT = 'EDITOR/SET_FRONT';
export const SET_BACK = 'EDITOR/SET_BACK';
export const SET_SUITE_ROOM = 'EDITOR/SET_SUITE_ROOM';
export const SET_FIRST_NAME = 'EDITOR/SET_FIRST_NAME';
export const SET_MIDDLE_NAME = 'EDITOR/SET_MIDDLE_NAME';
export const SET_LAST_NAME = 'EDITOR/SET_LAST_NAME';
export const SET_PRIMARY_TITLE = 'EDITOR/SET_PRIMARY_TITLE';
export const SET_SECONDARY_TITLE = 'EDITOR/SET_SECONDARY_TITLE';
export const SET_TITLE4 = 'EDITOR/SET_TITLE4';
export const SET_MAIN = 'EDITOR/SET_MAIN';
export const SET_DIRECT = 'EDITOR/SET_DIRECT';
export const SET_WEBSITE = 'EDITOR/SET_WEBSITE';
export const SET_PHONE_LABEL1 = 'EDITOR/SET_PHONE_LABEL1';
export const SET_PHONE_LABEL2 = 'EDITOR/SET_PHONE_LABEL2';
export const SET_PHONE_LABEL3 = 'EDITOR/SET_PHONE_LABEL3';
export const SET_PHONE_OTHER_LABEL1 = 'EDITOR/SET_PHONE_OTHER_LABEL1';
export const SET_PHONE_OTHER_LABEL2 = 'EDITOR/SET_PHONE_OTHER_LABEL2';
export const SET_PHONE_OTHER_LABEL3 = 'EDITOR/SET_PHONE_OTHER_LABEL3';
export const FETCH_CLINICS = 'EDITOR/FETCH_CLINICS';
export const FETCH_CLINICS_SUCCESS = 'EDITOR/FETCH_CLINICS_SUCCESS';
export const FETCH_CLINICS_ERROR = 'EDITOR/FETCH_CLINICS_ERROR';
export const FETCH_CLINIC_LOCATIONS = 'EDITOR/FETCH_CLINIC_LOCATIONS';
export const FETCH_CLINIC_LOCATIONS_SUCCESS = 'EDITOR/FETCH_CLINIC_LOCATIONS_SUCCESS';
export const FETCH_CLINIC_LOCATIONS_ERROR = 'EDITOR/FETCH_CLINIC_LOCATIONS_ERROR';
export const CHECK_AVAILABLE_ITEMS = 'EDITOR/CHECK_AVAILABLE_ITEMS';
export const CHECK_AVAILABLE_ITEMS_SUCCESS = 'EDITOR/CHECK_AVAILABLE_ITEMS_SUCCESS';
export const CHECK_AVAILABLE_ITEMS_ERROR = 'EDITOR/CHECK_AVAILABLE_ITEMS_ERROR';
export const SET_SCHEDULING_CARD = 'EDITOR/SET_SCHEDULING_CARD';
export const ADD_TITLE = 'EDITOR/ADD_TITLE';
export const REMOVE_TITLE = 'EDITOR/REMOVE_TITLE';
export const SET_PERSONS_NAMES = 'EDITOR/SET_PERSONS_NAMES';
export const SET_PERSONS_TITLES = 'EDITOR/SET_PERSONS_TITLES';
export const ADD_PERSON = 'EDITOR/ADD_PERSON';
export const REMOVE_PERSON = 'EDITOR/REMOVE_PERSON';
export const RESET_STATE = 'EDITOR/RESET_STATE';
export const SET_ACTION = 'EDITOR/SET_ACTION';
export const SET_ADD_TO_CART_ORDER_TYPE = 'EDITOR/SET_ADD_TO_CART_ORDER_TYPE';
export const SET_ADD_TO_CART_TYPE = 'EDITOR/SET_ADD_TO_CART_TYPE';
export const SET_PASSWORD = 'EDITOR/SET_PASSWORD';
export const SET_SHOW_CHECKS = 'EDITOR/SET_SHOW_CHECKS';
export const SET_ADD_ENVELOPES = 'EDITOR/SET_ADD_ENVELOPES';
export const ADD_LETTERHEAD_PERSON = 'EDITOR/ADD_LETTERHEAD_PERSON';
export const REMOVE_LETTERHEAD_PERSON = 'EDITOR/REMOVE_LETTERHEAD_PERSON';
export const SET_LETTERHEAD_PERSON_NAME = 'EDITOR/SET_LETTERHEAD_PERSON_NAME';
export const ADD_LETTERHEAD_PERSON_TITLE = 'EDITOR/ADD_LETTERHEAD_PERSON_TITLE';
export const REMOVE_LETTERHEAD_PERSON_TITLE = 'EDITOR/REMOVE_LETTERHEAD_PERSON_TITLE';
export const SET_LETTERHEAD_PERSON_TITLE = 'EDITOR/SET_LETTERHEAD_PERSON_TITLE';
export const SET_LETTERHEAD_PERSONS = 'EDITOR/SET_LETTERHEAD_PERSONS';
export const ADD_PRESCRIPTION_PAD_PERSON = 'EDITOR/ADD_PRESCRIPTION_PAD_PERSON';
export const REMOVE_PRESCRIPTION_PAD_PERSON = 'EDITOR/REMOVE_PRESCRIPTION_PAD_PERSON';
export const SET_PRESCRIPTION_PAD_PERSON_FIELD = 'EDITOR/SET_PRESCRIPTION_PAD_PERSON_FIELD';
export const REMOVE_PRESCRIPTION_PAD_PERSON_BY_INDEX = 'EDITOR/REMOVE_PRESCRIPTION_PAD_PERSON_BY_INDEX';
export const SET_PRESCRIPTION_PAD_PERSONS = 'EDITOR/SET_PRESCRIPTION_PAD_PERSONS';
export const SET_ADDITIONAL_FIELD = 'EDITOR/SET_ADDITIONAL_FIELD';
export const SET_WINDOW = 'EDITOR/SET_WINDOW';
export const SET_SHOW_SOCIAL_MEDIA_ICONS = 'EDITOR/SET_SHOW_SOCIAL_MEDIA_ICONS';
export const SET_LANGUAGE = 'EDITOR/SET_LANGUAGE';
export const SET_LOCATION_ID = 'EDITOR/SET_LOCATION_ID';
export const SET_CLINIC_ID = 'EDITOR/SET_CLINIC_ID';
export const SET_NURSE_PHONE = 'EDITOR/SET_NURSE_PHONE';
export const SET_FONT_TYPE = 'EDITOR/SET_FONT_TYPE';